// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__3fBHY","footer_text":"style_footer_text__ywbBf"};